import classes from "./Card.module.scss";
import { useScreenWidth } from "hooks/useScreenWidth";
import { EXTENDED_VIEW_WIDTH } from "constants/common";
export interface CardProps {
  title?: string;
  showDivider?: boolean;
  children?: React.ReactNode;
  shadow?: boolean;
  actions?: JSX.Element;
}

export const Card: React.FC<CardProps> = ({
  title,
  showDivider = true,
  children,
  shadow,
  actions,
}) => {
  const width = useScreenWidth();
  const compactView = width <= EXTENDED_VIEW_WIDTH;

  const actionClasses = [
    classes.actionsWrapper,
    compactView ? classes.actionsSplitView : "",
  ].join(" ");
  const wrapperClasses = [
    classes.Wrapper,
    shadow ? classes.BoxShadow : "",
  ].join(" ");

  return (
    <article className={wrapperClasses}>
      <div className={classes.header}>
        {actions &&
          <div className={actionClasses}>
            {actions}
          </div>
        }
        {title &&
          <div className={classes.titleWrapper}>
            <h3 className={classes.Heading}>{title}</h3>
          </div>
        }
      </div>
      {showDivider === true && (
        <ft-divider class={classes.Divider}></ft-divider>
      )}
      {children}
    </article>
  );
};
